export class DescendantsObserver {
  addedNodes: Array<Node>;
  nodeName: string;
  nodeTreatment: (array: Array<Node>) => void;
  mutationObserver: MutationObserver;

  /**
   * Creates the Mutation Observer that observes a NodeName and aplies the function (func) on them.
   * @param nodeName Node name reference that the observer is going to collect
   * @param func Function that is going to be applied on the added nodes
   */
  constructor(nodeName: string, func: (array: Array<Node>) => void) {
    this.addedNodes = [];

    this.nodeName = nodeName;
    this.nodeTreatment = func;

    this.mutationObserver = new MutationObserver(this.observerCallback.bind(this));
  }

  /**
   * Sets the Mutation Observer to observe a specific Node with the options given.
   * @param target A DOM Node to watch for changes
   * @param options An object providing options that describe which DOM mutations should be reported to mutationObserver's callback
   */
  observe(target: Node, options: MutationObserverInit): void {
    if (!options.childList) {
      options.childList = true;
    }
    this.mutationObserver.observe(target, options);
  }

  /**
   * Disconnect's the Mutation Observer
   */
  disconnect(): void {
    this.mutationObserver.disconnect();
  }

  /**
   * Mutation observer callback function
   */
  private observerCallback(nodeDescendants: Array<MutationRecord>) {
    nodeDescendants.forEach((descendant) => {
      if (descendant.type === 'childList' && descendant.addedNodes.length) {
        descendant.addedNodes.forEach((node) => {
          if (node.nodeName.toLowerCase() === this.nodeName) {
            this.addedNodes.push(node);
          }
        });
      }
    });

    this.nodeTreatment(this.addedNodes);
  }
}
